<template>
    <div>
      <h4>Logged Out</h4>
    </div>
</template>
<script>
//import axios from 'axios'

//const API_ENDPOINT = 'https://8c8gylju3m.execute-api.us-east-1.amazonaws.com/serverless_lambda_stage'

export default {
  name: 'App',
  components: {},

  data() {
    return {
      input: {
        username: "",
        password: ""
      }
    }
  },

  mounted() {
    this.$store.commit('login',"")
    //axios.get(API_ENDPOINT + "/expenses")
    //  .then(response => {
    //    this.expenses = response.data;
        console.log("User Logged Out");
    //  });
  },
  methods: {
  login() {
    if (this.input.username != "" && this.input.password != "") {
      if (this.input.username == "admin" && this.input.password == "password") {
        this.$store.commit('login',this.input.username)
        //this.$emit("authenticated", true);
        this.$router.replace({ name: "Home" });
      } 
      else {
        console.log("The username and / or password is incorrect");
      }
    }
    else {
      console.log("A username and password must be present");
    }
  }
}
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>